import dayjs from "dayjs";

/** Data de exibição: prioriza os campos Date (eventStartDate) e cai pros legados (string). */
export function formatEventDates(ev: {
  eventStartDate?: string;
  eventEndDate?: string;
  eventStart?: string;
  eventEnd?: string;
}): string {
  const start = ev.eventStartDate || ev.eventStart;
  const end = ev.eventEndDate || ev.eventEnd;
  const f = (v?: string) => {
    if (!v) return "";
    const d = dayjs(v);
    return d.isValid() ? d.format("MMM DD, YYYY") : String(v);
  };
  const s = f(start);
  const e = f(end);
  if (s && e && s !== e) return `${s} – ${e}`;
  return s || e || "—";
}

/** Local de exibição: venue + cidade/UF, sem vírgulas órfãs. */
export function formatVenue(ev: {
  venue?: string;
  venueCity?: string;
  venueState?: string;
}): string {
  const cityState = [ev.venueCity, ev.venueState].filter(Boolean).join(", ");
  return [ev.venue, cityState].filter(Boolean).join(" — ") || "—";
}

/**
 * Home city/state of a person as "Nashville, TN" — either half may be missing,
 * and empty string is as common as absent in this free-text address field.
 *
 * Same output as the `homeLocation` line in `components/Tooltip/ContactTool`:
 * the People row and the hover card sit next to each other, so a difference in
 * spacing or fallback would read as different data.
 */
export function formatPersonLocation(p: {
  city?: string | null;
  state?: string | null;
}): string {
  return [p.city, p.state]
    .map((v) => (typeof v === "string" ? v.trim() : ""))
    .filter(Boolean)
    .join(", ");
}

/** Papéis aprovados de um user pra exibir como chips (dedup + ordena). */
export function approvedRoleLabels(roles?: Array<{ role: string; status: string }>): string[] {
  const out = new Set<string>();
  (Array.isArray(roles) ? roles : []).forEach((r) => {
    if (r?.role && r.status === "approved") out.add(r.role);
  });
  return [...out].sort();
}

/**
 * State do deep-link pro /event/details (mesmo shape usado no AllEvents):
 * { id, contactId, coordinatorId }. assignedCoordinatorId legado pode ser
 * array OU valor único.
 */
export function eventDetailsState(ev: {
  _id?: string;
  eventId?: string;
  contactInformationId?: string | null;
  assignedCoordinatorId?: string | string[] | null;
}): { id: string; contactId: string | null; coordinatorId: string | null } {
  const coord = Array.isArray(ev.assignedCoordinatorId)
    ? ev.assignedCoordinatorId[0]
    : ev.assignedCoordinatorId;
  return {
    id: String(ev._id ?? ev.eventId ?? ""),
    contactId: ev.contactInformationId ? String(ev.contactInformationId) : null,
    coordinatorId: coord ? String(coord) : null,
  };
}
